// extracted by mini-css-extract-plugin
export default {"root":"SelectFromCloudEmpty__root--1BWxO","title":"SelectFromCloudEmpty__title--N7nye","text":"SelectFromCloudEmpty__text--1bMSz","image":"SelectFromCloudEmpty__image--1KCeW"};